# This gets automatically populated bij gulp

exports.date = 1476225035
exports.branch = "master"
exports.hash = "13eae19"
exports.build = 2317
exports.version = "#{exports.branch}/#{exports.hash}"



/** WEBPACK FOOTER **
 ** ./build/Version.coffee
 **/